// Libraries
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';

// Local
import hero from "../Assets/hero.svg";
import NotesIcon from '@mui/icons-material/Notes';
import DataObjectIcon from '@mui/icons-material/DataObject';
import iniLogo from '../Assets/ini_logo.png';
import iniLogoDark from '../Assets/ini_logo_dark.png';
import ethLogo from '../Assets/eth_logo_kurz_pos.svg';
import ethLogoDark from '../Assets/eth_logo_kurz_neg.svg';
import uzhLogo from '../Assets/uzh-logo.svg';
import uzhLogoDark from '../Assets/uzh-logo-white.png';
import epflLogo from '../Assets/epfl_logo.png';
import swissuniversitiesLogo from '../Assets/swissuniversities_logo.png';

const Hero = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  // Determine the current mode and the icon/label for the toggle.
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <Stack
      direction='row'
      sx={{
        width: '100%',
        flexWrap: 'auto',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Stack
        direction="column"
        sx={{
          gap: '1.5vh',
          textAlign: 'left',
          width: { xs: '100%', md: 'auto' },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 'bold',
          }}
        >
          Rethink reading
        </Typography>
        <Typography
          variant="h6"
          sx={{
          }}
        >
          Discover the scientific literature with a little help from AI.
        </Typography>
        <Stack
          direction='row'
          sx={{
            width: '100%',
            gap: '2%',
            flexWrap: 'auto',
            alignItems: 'center',
            justifyContent: 'left',
          }}
        >
          <Button
            endIcon={<NotesIcon />}
            sx={{
              alignSelf: 'flex-start',

              borderRadius: 3,
              px: 2,
              py: 1.25,
              
              color: 'white',
              background: '#265ed5',
              border: 'none',

              textTransform: 'none',
              '&:hover': {
                background: '#265ed5',
              },
            }}
            onClick={() => navigate('/login')}
          >
            <Typography 
              sx={{ fontWeight: 'bold' }}
            >
              Try Endoc now
            </Typography>
          </Button>
          <Button
            endIcon={<DataObjectIcon />}
            sx={{
              alignSelf: 'flex-start',

              borderRadius: 3,
              px: 2,
              py: 1.25,
              
              color: 'white',
              background: '#fbd343',
              border: 'none',
              
              textTransform: 'none',
              '&:hover': {
                background: '#fbd343',
              },
            }}
            onClick={() => {
              window.open(
                "https://pypi.org/project/endoc/",
                '_blank',
                'noreferrer'
              );
            }}
          >
            <Typography 
              sx={{ fontWeight: 'bold' }}
            >
              For developers
            </Typography>
          </Button>
        </Stack>
        <Typography
          sx={{ fontWeight: 'bold', color: 'grey'}}
        >
          Trusted by
        </Typography>
        <Stack 
          direction="row" 
          sx={{ 
            columnGap: '2vh',
            rowGap: '1vh',
            flexWrap: 'wrap',
        }}>
          <Box 
            component="img" 
            src={isDarkMode? iniLogoDark : iniLogo} 
            alt="INI" 
            sx={{ width: '100px' }} 
          />
          <Box component="img" src={isDarkMode ? ethLogoDark : ethLogo} alt="ETH Zurich" sx={{ width: '100px' }} />
          <Box component="img" src={isDarkMode ? uzhLogoDark : uzhLogo} alt="UZH" sx={{ width: '100px' }} />
          <Box component="img" src={epflLogo} alt="EPFL" sx={{ width: '100px' }} />
          <Box component="img" src={swissuniversitiesLogo} alt="Swiss Universities" sx={{ width: '100px' }} />
        </Stack>
      </Stack>
      <Box
        component="img"
        src={hero}
        sx={{ 
          marginTop: { xs: '2vh', md: '0' },
        }}
      />
    </Stack>
  );
};

export default Hero;
